import { createApp } from 'vue';
import ConfirmModal from '@/components/modals/ConfirmModal';
import utilsService from '@/services/core/utils.service';

export default class ModalService {
    static instances = [];

    static show(component, data = {}, callback) {
        document.body.style.overflow = 'hidden';
        document.activeElement && document.activeElement.blur();

        const instance = {
            modalId: `ap-modal-${utilsService.uuid()}`,
            callback,
            component: createApp(component, { modalData: data })
        };

        const modalContainer = document.createElement('div');
        modalContainer.id = instance.modalId;
        document.body.appendChild(modalContainer);
        instance.component.mount(modalContainer);
        this.instances.push(instance);
    }

    static closeModal(isCancel) {
        let index = ModalService.instances.length - 1;
        const instance = ModalService.instances[index] || {};

        if (!isCancel) {
            if (instance.callback && typeof instance.callback === 'function') instance.callback();
        }

        if (instance.component && typeof instance.component.unmount == 'function') instance.component.unmount();

        const $modal = document.getElementById(instance.modalId);
        $modal && document.body.removeChild($modal);
        ModalService.instances.splice(index, 1);

        if (!ModalService.instances.length) document.body.style.overflow = 'auto';
    }

    static confirm = ({ title, msg, onCancel, onSuccess, btnTextCancel, btnTextOk }) => {
        ModalService.show(ConfirmModal, {
            title,
            msg,
            onCancel,
            onSuccess,
            btnTextCancel,
            btnTextOk
        });
    };
}
